"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
/**
 * @author Vahagn Lazyan.
 * @since 2.4.0
 */
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var immutable_1 = require("immutable");
var utilities_1 = require("../../utilities");
var Subject_1 = require("rxjs/Subject");
var zip_1 = require("rxjs/observable/zip");
require("./sis-radio-settings.component.scss");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var lodash_1 = require("lodash");
var SisRadioSettingsComponent = /** @class */ (function (_super) {
    __extends(SisRadioSettingsComponent, _super);
    function SisRadioSettingsComponent(kbService, communicationService) {
        var _this = _super.call(this, communicationService) || this;
        _this.kbService = kbService;
        _this.communicationService = communicationService;
        _this.availableActions = [];
        _this.aptActions = [];
        _this.compatibleMetaFields = immutable_1.Map();
        _this.isReady = false;
        _this._selectedMetaField = undefined;
        _this.defaultMetaGroup = new idm_kb_service_client_js_1.MetaGroup('', 'de.default.meta.group', []);
        _this.destroySubject$ = new Subject_1.Subject();
        return _this;
    }
    SisRadioSettingsComponent_1 = SisRadioSettingsComponent;
    SisRadioSettingsComponent.isFieldCompatible = function (metaField) {
        return (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER &&
            !metaField.getIsSystemField());
    };
    SisRadioSettingsComponent.getBindings = function () {
        return {
            click: 'actions.nop()',
            isReadonly: false,
        };
    };
    Object.defineProperty(SisRadioSettingsComponent.prototype, "fields", {
        set: function (fields) {
            var _this = this;
            this._selectedMetaField = fields.checkedItem
                ? fields.checkedItem.getMetaFieldId().getSystemName()
                : undefined;
            if (!lodash_1.isNil(this._selectedMetaField)) {
                this.aptActions = this.availableActions.filter(function (action) {
                    return lodash_1.isNil(action.fields) || (!lodash_1.isNil(action.fields) &&
                        action.fields.some(function (field) { return field === _this._selectedMetaField; }));
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRadioSettingsComponent.prototype, "selectedMetaField", {
        get: function () {
            return this._selectedMetaField;
        },
        set: function (metaField) {
            this._selectedMetaField = metaField ? metaField : undefined;
            this.valueChange();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRadioSettingsComponent.prototype, "selectedAction", {
        get: function () {
            return this._selectedAction;
        },
        set: function (value) {
            var _this = this;
            this._selectedAction = value;
            this.aptActions = this.availableActions.filter(function (action) {
                return lodash_1.isNil(action.fields) || (!lodash_1.isNil(action.fields) &&
                    action.fields.some(function (field) { return field === _this._selectedMetaField; }));
            });
            this.valueChange();
        },
        enumerable: true,
        configurable: true
    });
    SisRadioSettingsComponent.prototype.valueChange = function () {
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
            bindings: SisRadioSettingsComponent_1.getBindings(),
            state: this.getState(),
            actions: __assign({}, this.controlActions, { 'dataItems': !lodash_1.isNil(this._selectedAction) ? this._selectedAction.actionName
                    : this.controlActions['dataItems'] }),
            fields: {
                checkedItem: this._selectedMetaField
                    ? this.compatibleMetaFields.get(this._selectedMetaField)
                        .metaField
                    : undefined,
            },
        }));
    };
    SisRadioSettingsComponent.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    SisRadioSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!lodash_1.isNil(this.controlActions['dataItems'])) {
            this._selectedAction =
                this.availableActions.find(function (action) { return action.actionName === _this.controlActions['dataItems']; });
        }
        var metaGroups$ = this.kbService
            .getNonSystemMetaGroups(this.category)
            .pipe(operators_1.first());
        var metaFields$ = this.kbService
            .getMetaFields(this.category)
            .pipe(operators_1.first());
        zip_1.zip(metaGroups$, metaFields$)
            .pipe(operators_1.first())
            .subscribe(function (data) {
            var metaFields = data[1];
            var metaGroups = data[0];
            _this.compatibleMetaFields = _this.compatibleMetaFields.withMutations(function (mutableCompatibleMetaFields) {
                metaFields
                    .filter(SisRadioSettingsComponent_1.isFieldCompatible)
                    .forEach(function (metaField) {
                    var metaGroup = metaGroups.find(function (group) {
                        return group.getSystemName() ===
                            metaField
                                .getMetaFieldId()
                                .getMetaGroupId()
                                .getSystemName();
                    });
                    mutableCompatibleMetaFields.set(metaField.getSystemName(), {
                        metaField: metaField,
                        metaGroup: metaGroup ||
                            _this.defaultMetaGroup,
                    });
                });
            });
            _this.isReady = true;
        }, function (err) { return console.error(err); });
    };
    SisRadioSettingsComponent.prototype.hintChanged = function (hint) {
        this.hint = hint;
        this.valueChange();
    };
    SisRadioSettingsComponent.prototype.getState = function () {
        return {
            hint: utilities_1.multilingualToString(this.hint),
            tooltipSettings: this._tooltipSettings
                ? this._tooltipSettings.toJsonString()
                : undefined,
        };
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisRadioSettingsComponent.prototype, "controlActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisRadioSettingsComponent.prototype, "availableActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisRadioSettingsComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisRadioSettingsComponent.prototype, "fields", null);
    SisRadioSettingsComponent = SisRadioSettingsComponent_1 = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-radio-settings',
            template: require('./sis-radio-settings.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<sis-radio-settings [category]=\"%{category}\" [fields]=\"%{fields}\" [state]=\"%{state}\"\n                                                    [controlActions]=\"%{actions}\"\n                                                     [availableActions]=\"%{availableActions}\"\n                                                  [languages]=\"%{languages}\" [currentLanguageId]=\"%{currentLanguageId}\"\n                                                  [controlLabel]=\"%{controlLabel}\">\n                              </sis-radio-settings>",
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_dynamic_controls_metadata_1.CommunicationService])
    ], SisRadioSettingsComponent);
    return SisRadioSettingsComponent;
    var SisRadioSettingsComponent_1;
}(idm_ng_controls_1.BaseSettings));
exports.SisRadioSettingsComponent = SisRadioSettingsComponent;
//# sourceMappingURL=sis-radio-settings.component.js.map